import type { ClassificationLevel, GoClassificationLevel } from "@shared/utils";

const CLASSIFICATION_I18N: Record<ClassificationLevel, string> = {
  high: "admin.structures.anmClassification.classification.high",
  medium: "admin.structures.anmClassification.classification.medium",
  low: "admin.structures.anmClassification.classification.low",
};

export const formatClassificationBandLabel = (
  translate: (key: string) => string,
  level?: ClassificationLevel | null,
): string => {
  if (!level) {
    return "—";
  }

  return translate(CLASSIFICATION_I18N[level]);
};

export const formatGoDisplayValue = (
  gopClass?: string | null,
): string => {
  if (!gopClass) {
    return "—";
  }

  return gopClass.toUpperCase();
};

export const mapGoLevelToClassificationLevel = (
  gopClass?: string | null,
  classificationLevel?: ClassificationLevel | null,
): ClassificationLevel | undefined => {
  if (gopClass) {
    const normalized = gopClass.toLowerCase() as GoClassificationLevel;
    if (normalized === "aa" || normalized === "a") return "low";
    if (normalized === "b") return "medium";
    return "high";
  }

  return classificationLevel ?? undefined;
};
